import Header from "../../components/header/Header";
import Posts from "../../components/posts/Posts";
import Sidebar from "../../components/sidebar/Sidebar";
import "./homepage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import InstagramEmbed from "../../components/instagram/InstagramEmbed";
import Categories from "../../components/categories/Categories";
import MainContent from "../../components/mainContent/MainContent";
import Gallery from "../../components/gallery/Gallery";
import Articles from "../articles/Articles";

export default function Homepage({ aboutBlog }) {
  // const location = useLocation();

  // const [posts, setPosts] = useState([]);
  // const [page, setPage] = useState(1);
  // const [pageSize] = useState(4); // or any number you want
  // const [totalPages, setTotalPages] = useState(1);

  const [featuredPost, setFeaturedPost] = useState(null);
  // const [categoryTitle, setCategoryTitle] = useState("All Articles");
  const [search, setSearch] = useState("?");

  // // let search = "";
  // switch (location?.search?.split("=")[0]) {
  //   case "?cat":
  //     search = `?filters[categories][documentId][$eq]=${
  //       location.search.split("=")[1]
  //     }&`;
  //     setCategoryTitle('')
  //     break;
  //   case "?author":
  //     search = `?filters[author][documentId][$eq]=${
  //       location.search.split("=")[1]
  //     }&`;
  //     break;
  //   case "?createdAt":
  //     const dateRange = {
  //       zeroHour: "T00:00:00.000Z",
  //       lastHour: "T23:59:59.999Z",
  //     };
  //     search = `?filters[createdAt][$gte]=${
  //       location.search.split("=")[1].split("T")[0]
  //     }${dateRange.zeroHour}&filters[createdAt][$lte]=${
  //       location.search.split("=")[1].split("T")[0]
  //     }${dateRange.lastHour}&`;
  //     break;
  //   default:
  //     search = "?";
  //     break;
  // }

  // Fetch featured post only once
  useEffect(() => {
    const fetchFeaturedPost = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/posts?filters[isFeatured][$eq]=true&populate=photo&populate=categories`,
          // {
          //   headers: {
          //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
          //   },
          // }
        );

        setFeaturedPost(res.data.data || null); // assuming only one featured post
      } catch (error) {
        console.log(error);
      }
    };
    fetchFeaturedPost();
  }, []);

  return (
    <>
      <Header aboutData={aboutBlog} />
      <MainContent featuredPost={featuredPost} />

      <Articles pgSize={4} intro={true} />

      {/* <div className="postsContainer">
        <Categories />

        <div className="d-flex flex-column w-100 justify-content-center align-items-center">
          <h2>{categoryTitle}</h2>
          <Posts posts={posts} />
          <div className="pagination">
            <button
              disabled={page <= 1}
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            >
              Previous
            </button>

            <span>
              Page {page} of {totalPages}
            </span>

            <button
              disabled={page >= totalPages}
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            >
              Next
            </button>
          </div>
        </div>
      </div> */}

      {/* <div className="p-4">
        <Gallery title={"Latest Products"} description="latest Products" />
      </div> */}
    </>
  );
}
